import { render, staticRenderFns } from "./addTg.vue?vue&type=template&id=0c12491f&scoped=true"
import script from "./addTg.vue?vue&type=script&lang=js"
export * from "./addTg.vue?vue&type=script&lang=js"
import style0 from "./addTg.vue?vue&type=style&index=0&id=0c12491f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c12491f",
  null
  
)

export default component.exports